import { useCurrentOrganisation } from '#pie/auth';
import {
  AuthorizationRoles,
  useGetKnowledgeArticle,
} from '#pie/internal/api/pie-bff';
import { hasRole } from '#pie/internal/libs/auth';

export const useRelatedKnowledgeArticles = (
  mainCategoryId?: string | string[],
  subCategoryId?: string | string[],
) => {
  const { currentAccount } = useCurrentOrganisation();

  const {
    data: relatedArticlesData,
    isFetching: relatedArticlesLoading,
    error,
  } = useGetKnowledgeArticle(
    {
      filter: {
        mainCategoryIds: Array.isArray(mainCategoryId)
          ? mainCategoryId
          : [mainCategoryId!],
        subCategoryIds: subCategoryId
          ? Array.isArray(subCategoryId)
            ? subCategoryId
            : [subCategoryId]
          : undefined,
      },
      sorting: {
        field: 'modifiedOn',
        descending: true,
      },
      pagination: {
        pageIndex: 0,
        pageSize: 10,
      },
    },
    {
      query: {
        enabled:
          !!mainCategoryId &&
          mainCategoryId.length > 0 &&
          currentAccount &&
          hasRole([AuthorizationRoles.KnowledgeArticles], currentAccount.roles),
      },
    },
  );

  return {
    relatedArticles: relatedArticlesData?.items,
    relatedArticlesLoading,
    error,
  };
};
